const common = {
  'common.loading': 'Loading...',
  'common.nav.home': 'Home',
};

export default common;
